/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
import { camelCase, uniqueId } from 'lodash';

function handleInitialAdjustments({ questionnaire }) {
  return questionnaire.map(question => {
    return question;
  })
}

function handleCNAESecondary({
  borrowerData,
  CNAESecondary,
  setCNAESecondary,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete
}) {
  let list = []

  const question = CNAESecondary[0].find(q => q.idQuestion === 1650);

  borrowerData.cnaeSecundarias.map((item, index) => {
    const cnaeSecdivision = (question.childrenQuestions && question.childrenQuestions[0]) || null;

    if (cnaeSecdivision) {
      const cnaeSec = item.codigo.substring(0, 2);
      if ([41, 42, 43].includes(Number(cnaeSec))) {
        cnaeSecdivision.idAnswerOption = 7316;
        cnaeSecdivision.answer = cnaeSecdivision.answerOptions.find(v => v.idAnswerOption === 7316).dsAnswerOption;
      } else {
        cnaeSecdivision.idAnswerOption = 7315;
        cnaeSecdivision.answer = cnaeSecdivision.answerOptions.find(v => v.idAnswerOption === 7315).dsAnswerOption;
      }
    };

    list.push([{
      ...question,
      answer: `${item.codigo} - ${item.descricao}`,
      key: `${camelCase(question.dsQuestion)}_${question.idQuestion}${uniqueId()}_${uniqueId()}`,
      idQuestionnaireAnswers: null,
      idQuestionnaireAnswersParent: null,
      idQuestionnaireAnswersRoot: null,
      childrenQuestions: !cnaeSecdivision ? [] : [{
        ...cnaeSecdivision,
        key: `${camelCase(question.dsQuestion)}_${question.idQuestion}${uniqueId()}_${uniqueId()}`,
        idQuestionnaireAnswers: null,
        idQuestionnaireAnswersParent: null,
        idQuestionnaireAnswersRoot: null,
      }]
    }])
  })

  if (questionnaireAnswersToDelete) {
    for (const cNAESecondaryGroup of CNAESecondary || []) {
      questionnaireAnswersToDelete =
        [
          ...questionnaireAnswersToDelete,
          ...cNAESecondaryGroup.filter(q => q.idQuestionnaireAnswers).map(q => q.idQuestionnaireAnswers)
        ].filter(v => v)
    }
    setQuestionnaireAnswersToDelete && setQuestionnaireAnswersToDelete(questionnaireAnswersToDelete);
  }
  setCNAESecondary(list)
}

const events = {
  handleInitialAdjustments,
  handleCNAESecondary,
}

export { events };
